/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Autocomplete } from '@mui/material';
import { FormikProps } from 'formik';
import { useGetUsersQuickQuery } from 'src/common/apis/AdminApi';

import { ReactComponent as SearchIcon } from '../../../../common/assets/icons/search_icon_small_gray.svg';

import OrganizationInput from './OrganizationInput';

type Props = {
  value: string;
  formik: FormikProps<any>;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const OwnerAutocompleteInput: React.FC<Props> = ({
  value,
  formik,
  disabled = false,
  onChange,
}) => {
  const [inputValue, setInputValue] = React.useState<string>(value ?? '');
  const { data, isFetching: isLoading } = useGetUsersQuickQuery(undefined, {
    skip: disabled,
    refetchOnMountOrArgChange: true,
  });

  return (
    <Autocomplete
      id='owner-autocomplete-input'
      options={data ? data.map((item) => item.email) : []}
      onChange={(_event, newValue) => onChange(newValue ?? '')}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      loading={isLoading}
      disabled={disabled}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <OrganizationInput
          {...params}
          title='Owner'
          startIcon={<SearchIcon />}
          error={formik.touched['owner'] && Boolean(formik.errors['owner'])}
          helperText={formik.touched['owner'] && formik.errors['owner']}
          disabled={disabled}
        />
      )}
    />
  );
};

export default OwnerAutocompleteInput;
